
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { useLanguagePath } from "@/utils/language";
import { useTranslations } from "@/hooks/useTranslations";

export const SessionsHeader = () => {
  const { getPath } = useLanguagePath();
  const { t } = useTranslations("training-sessions");
  
  return (
    <div className="space-y-2">
      <h2 className="text-3xl font-bold tracking-tight gradient-text text-slate-950 dark:text-white">{t("title")}</h2>
      <p className="text-muted-foreground dark:text-gray-300">
        {t("subtitle")}
      </p>
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink href={getPath("/dashboard")} className="text-flame hover:text-flame/80">Dashboard</BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage className="font-medium dark:text-white">{t("title")}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};
